module.exports = __webpack_public_path__ + "static/media/4.823234a7.jpg";